const driversOnline = {
  driversOnline: 'Motoristas on-line',

  table: {
    headers: {
      name: 'Nome',
      phone: 'Número de telefone',
      status: 'Status',
      vehicle: 'Veículo',
      activeSince: 'Ativo desde',
      sum: 'Soma',
      pax: 'Pax',
      earned: 'Ganho',
    },
    driverStatusOptions: {
      online: 'Online',
      enRoute: 'Em rota',
      break: 'Pausa',
      endBreak: 'Fim do intervalo',
    },
    actions: {
      deactivate: 'Suspender',
    },
  },

  form: {
    fields: {
      driver: 'Motorista',
      vehicle: 'Veículo',
    },
    activateButton: 'Conectar-se',
  },

  deactivateModal: {
    header: 'Desativar motorista',
    body: 'Você tem certeza de que deseja desativar o {{driver}}?',
  },
  breakModal: {
    header: 'Intervalo do Motorista',
    body: 'Você tem certeza de que deseja liberar {{driver}} para um intervalo?',
  },
};

export default driversOnline;
